import { createAction } from 'redux-actions';

import { SearchResultFlightDirectionFragment, ExchangeVariantPriceInfoFragment } from '@websky/graphql';

export const FETCH_EXCHANGE_VARIANTS = 'EXCHANGE/FETCH_EXCHANGE_VARIANTS';
export const FETCH_EXCHANGE_PRICE = 'EXCHANGE/FETCH_EXCHANGE_PRICE';
export const ADD_SELECTED_FLIGHT = 'EXCHANGE/ADD_SELECTED_FLIGHT';
export const SET_ACTUAL_SELECTED_FLIGHT_PRICE_ID = 'EXCHANGE/SET_ACTUAL_SELECTED_FLIGHT_PRICE_ID';
export const REMOVE_LAST_SELECTED_FLIGHT = 'EXCHANGE/REMOVE_LAST_SELECTED_FLIGHT';
export const SET_EXCHANGE_VARIANTS = 'EXCHANGE/SET_EXCHANGE_VARIANTS';
export const SET_EXCHANGE_VARIANT_PRICES = 'EXCHANGE/SET_EXCHANGE_VARIANT_PRICES';
export const CLEAR_EXCHANGE_VARIANTS = 'EXCHANGE/CLEAR_EXCHANGE_VARIANTS';

export interface SetExchangeVariantsPayload {
	flightDirections: SearchResultFlightDirectionFragment[];
	exchangeVariantPriceInfo: ExchangeVariantPriceInfoFragment[];
}

export interface AddSelectedFlightPayload {
	groupId: string;
	priceId: string;
}

export interface SetActualSelectedFlightPriceIdPayload {
	priceId: string;
	actualPriceId: string;
}

export const fetchExchangeVariants = createAction(FETCH_EXCHANGE_VARIANTS);

export const fetchExchangePrice = createAction(FETCH_EXCHANGE_PRICE);

export const setExchangeVariants = createAction<SetExchangeVariantsPayload>(SET_EXCHANGE_VARIANTS);

export type SetExchangeVariantsAction = ReturnType<typeof setExchangeVariants>;

export const setExchangeVariantPrices = createAction<ExchangeVariantPriceInfoFragment[]>(SET_EXCHANGE_VARIANT_PRICES);

export type SetExchangeVariantPrices = ReturnType<typeof setExchangeVariantPrices>;

export const addSelectedFlight = createAction<AddSelectedFlightPayload>(ADD_SELECTED_FLIGHT);

export type AddSelectedFlightAction = ReturnType<typeof addSelectedFlight>;

export const setActualSelectedFlightPriceId = createAction<SetActualSelectedFlightPriceIdPayload>(
	SET_ACTUAL_SELECTED_FLIGHT_PRICE_ID
);

export const removeLastSelectedFlight = createAction(REMOVE_LAST_SELECTED_FLIGHT);

export type RemoveLastSelectedFlightAction = ReturnType<typeof removeLastSelectedFlight>;

export const clearExchangeVariants = createAction(CLEAR_EXCHANGE_VARIANTS);

export type ClearExchangeVariantsAction = ReturnType<typeof clearExchangeVariants>;
